// Central content store for Yi Kozhikode site
export const STATS = [
  { value: "6500+", label: "Members nationally" },
  { value: "66", label: "Chapters across India" },
  { value: "175K+", label: "Thalir students reached" },
  { value: "261", label: "Rural pockets touched" },
];

export const VERTICALS = [
  {
    slug: "thalir",
    pillar: "Youth Leadership",
    name: "Thalir",
    tag: "School Outreach",
    desc: "Sparking curiosity and conscience in school students across Kozhikode — from values to entrepreneurship to climate action.",
  },
  {
    slug: "yuva",
    pillar: "Youth Leadership",
    name: "Yuva",
    tag: "College Outreach",
    desc: "Empowering Calicut’s college students to lead student chapters, run projects and shape campus culture.",
  },
  {
    slug: "rural",
    pillar: "Nation Building",
    name: "Rural Initiatives",
    tag: "Hinterland First",
    desc: "Working with villages around Kozhikode on livelihoods, market access and dignity-led development.",
  },
  {
    slug: "masoom",
    pillar: "Nation Building",
    name: "Masoom",
    tag: "Personal Safety",
    desc: "Child sexual abuse awareness for students, teachers and parents — because every child deserves a safe shore.",
  },
  {
    slug: "road-safety",
    pillar: "Nation Building",
    name: "Road Safety",
    tag: "Safewalk",
    desc: "Pedestrian-first campaigns, zebra crossings and the Good Samaritan culture — making Calicut streets safer.",
  },
  {
    slug: "accessibility",
    pillar: "Nation Building",
    name: "Accessibility",
    tag: "Inclusive Cities",
    desc: "Project Disha-inspired work on tactile maps, sign language, and inclusive public spaces.",
  },
  {
    slug: "climate",
    pillar: "Nation Building",
    name: "Climate Change",
    tag: "Coastal Stewardship",
    desc: "River clean-ups, urban forestation, e-waste drives and the 7-day sustainability challenge.",
  },
  {
    slug: "health",
    pillar: "Nation Building",
    name: "Yi Health",
    tag: "Drug-Free Future",
    desc: "Mental health, fitness and our flagship 'Towards a Drug-Free Future' campaign in colleges and schools.",
  },
  {
    slug: "entrepreneurship",
    pillar: "Thought Leadership",
    name: "Entrepreneurship",
    tag: "YiBE / Launchpad",
    desc: "Peer-driven YiBE sessions, Yuva Launchpad and The Big Pitch — Kozhikode’s next generation of founders.",
  },
  {
    slug: "leadership",
    pillar: "Youth Leadership",
    name: "Learning",
    tag: "Missions & Sessions",
    desc: "Industrial visits, learning missions, book clubs and cross-chapter exchanges that compound over time.",
  },
  {
    slug: "innovation",
    pillar: "Thought Leadership",
    name: "Innovation",
    tag: "Kutty Makers",
    desc: "Tinkering, robotics and 3D printing for school students — Calicut’s makerspace mindset.",
  },
  {
    slug: "csr",
    pillar: "Nation Building",
    name: "CSR & Partnerships",
    tag: "Co-create",
    desc: "Partnerships with NGOs, government and corporates to scale chapter projects with real-world rigour.",
  },
];

export const EVENTS = [
  {
    name: "Inspiration Summit",
    blurb: "Our flagship gathering of changemakers, founders and student leaders — Calicut edition.",
  },
  {
    name: "SpiceRoute",
    blurb: "An immersive city walk through Kozhikode’s trading past, designed for new members.",
  },
  {
    name: "YiBE",
    blurb: "Peer-led entrepreneurship sessions — strategy, scale and storytelling, every month.",
  },
  {
    name: "TakePride",
    blurb: "The Yi national marquee event — Kozhikode shows up, loud and proud.",
  },
];

export const VERTICAL_OPTIONS = VERTICALS.map((v) => v.name).concat(["Membership", "Partnerships", "Other"]);
